var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedBinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.99 5.931l-.839 4.51c-.103.498-.527.8-1.015.806H5.908l-.242 1.283h11.653c.614.044 1.03.451 1.038.972-.045.574-.48.965-1.038.972H4.43c-.697-.058-1.112-.58-1.037-1.158l.552-2.813L3.105 2.6.722 1.897c-.583-.216-.82-.71-.685-1.22A1.097 1.097 0 011.34.036l3.045.91c.41.144.647.459.707.827l.176 1.572 13.817 1.448c.635.13.98.6.905 1.138zM7.588 16.516c0 .82-.71 1.484-1.584 1.484-.874 0-1.583-.665-1.583-1.484 0-.82.709-1.484 1.583-1.484.875 0 1.584.664 1.584 1.484zm9.454 0c0 .82-.709 1.484-1.584 1.484-.874 0-1.583-.665-1.583-1.484 0-.82.709-1.484 1.583-1.484.875 0 1.584.664 1.584 1.484z",
    fill: "#fff"
  })));
}

export default SvgLedBinIcon;